import { css } from '../../styles/theme';
import { IButtonStyles } from '../Button/ButtonStyled';
import { rem } from 'polished';

export const StylesOV = css<IButtonStyles>`
    padding: ${rem(10)} ${rem(65)};
    
    &:hover {
        transition: all .3s ease;
    }
    
    ${({ primary }) =>
        primary &&
        css`
            color: ${({ theme }) => theme.colors.black};
            background-color: ${({ theme }) => theme.colors.primary};
            border: 1px solid ${({ theme }) => theme.colors.primary};

            &:hover {
                color: ${({ theme }) => theme.colors.pureWhite};
                background-color: ${({ theme }) => theme.colors.black};
                border-color: ${({ theme }) => theme.colors.black};
            }
        `}
    
    ${({ secondary }) =>
        secondary &&
        css`
            color: ${({ theme }) => theme.colors.black2};
            border: none;
            background: ${({ theme }) => theme.colors.blue1};
            &:hover {
                background: ${({ theme }) => theme.colors.secondaryHover};
                color: ${({ theme }) => theme.colors.blue1};
            }
        `}
    
    ${({ primary, disabled }) =>
        primary &&
        disabled &&
        css`
            border-color: ${({ theme }) => theme.colors.primaryDisabled};
        `}
    
    ${({ secondary, disabled }) =>
        secondary &&
        disabled &&
        css`
            background: ${({ theme }) => theme.colors.secondaryDisabled};
            border-color: ${({ theme }) => theme.colors.secondaryDisabled};
            color: ${({ theme }) => theme.colors.black2};
        `}
`;
